import cn from 'classnames';
import * as React from 'react';
import { useTheme } from '../../../theme';
import { useTranslation } from 'react-i18next';
import { default as CloseButton } from '../../../BaseComponents/Button/components/CloseButton/CloseButton';

export interface Props {
	text?: string;
	onClose?: () => void;
	closeClassName?: string;
	textClassName?: string;
}

const FullscreenDialogClose: React.FC<Props> = ({ text, onClose, closeClassName, textClassName }) => {
	const { FullscreenDialog: theme } = useTheme('FullscreenDialog');
	const { t } = useTranslation('FullscreenDialog');

	return (
		<div className={cn(theme.close, closeClassName)} onClick={onClose}>
			<span className={cn(theme.close__text, textClassName)}>{text ?? t('Close')}</span>

			<CloseButton variant="closeFullscreen" className={theme.close__icon} />
		</div>
	);
};

export default FullscreenDialogClose;
